// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__yk6Ci","footer":"Form_footer__3Hbfh"};